// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"b897874c","215":"07434cc5","239":"7c3351d7","330":"0efac943","387":"ca3e0211","427":"e216d2db","453":"258b012d","732":"b498a8b3","822":"5f30b91e","977":"a5c2f382"}[chunkId] + ".chunk.js";
};